"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
exports.isConfigError = function (errors) { return isPlainObject_1["default"](errors); };
//# sourceMappingURL=types.js.map